import loadScript from 'load-script';

let initialized = false;

const removeElementByIds = (ids: string[]) => {
  ids.forEach((id) => {
    const element = document.getElementById(id);
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  });
};

const listener = function (e: any) {
  const t = e.data[0],
    a = e.data[1];
  switch (t) {
    case 'setContactFormHeight':
      const elem = document.getElementById('deskcontactwidgetframe') as HTMLCanvasElement;
      elem.height = Math.min(a, window.window.innerHeight - 75);
      break;
    default:
      return;
  }
};

declare global {
  interface Window {
    deskcontactwidget: any;
  }
}

export const initializeWidget = () => {
  if (initialized || process.env.REACT_APP_INSTANCE_TYPE !== 'production') {
    return;
  }

  window.deskcontactwidget = {};
  loadScript(
    `${process.env.REACT_APP_SUPPORT_WIDGET_BASE}/support/v1/contact/main.js?token=${process.env.REACT_APP_SUPPORT_WIDGET_TOKEN}`,
    {
      async: true,
      attrs: {
        id: 'teamwork-desk',
      },
    },
    (err) => {
      initialized = true;
    },
  );

  window.addEventListener('message', listener, !1);
  initialized = true;
};

export function RemoveWidget() {
  if (!initialized) {
    return;
  }

  removeElementByIds(['teamwork-desk', 'deskWidgetMain']);
  const links = document.getElementsByTagName('link');
  for (let i = 0; i < links.length; i++) {
    const element = links[i];
    if (
      element.getAttribute('href') ===
      `${process.env.REACT_APP_SUPPORT_WIDGET_BASE}/support/widget/main.css`
    ) {
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  delete window.deskcontactwidget;
  window.removeEventListener('message', listener, !1);
  initialized = false;
}
